exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".draggable[data-v-3bc2b79e]{cursor:move}.draggable.is-pointer-down[data-v-3bc2b79e]{background:#09f;z-index:2}.draggable.is-dragging[data-v-3bc2b79e]{opacity:.7}", ""]);

// exports
